import React from 'react';

interface TabItem {
  label: string;
  value: string;
}

interface TabsCardProps {
  tabs: TabItem[];
  activeIndex?: number;
  activeTab?: string;
  onChange?: (tabValue: number | string, index?: number) => void;
  className?: string;
  type?: 'card' | 'underline';
}

const TabsCard: React.FC<TabsCardProps> = ({
  tabs,
  activeIndex = 0,
  activeTab,
  onChange,
  className = '',
  type = 'card'
}) => {
  if (type === 'underline') {
    return (
      <div className={`mb-3 px-4 ${className}`}>
        <div className="flex gap-4">
          {tabs.map(tab => (
            <div
              key={tab.value}
              className="flex cursor-pointer flex-col items-center gap-1"
              onClick={() => onChange?.(tab.value)}
            >
              <span
                className={`text-sm font-medium transition-colors ${
                  activeTab === tab.value ? 'text-[#5959EB]' : 'text-[#1F1F1F]'
                }`}
              >
                {tab.label}
              </span>
              {activeTab === tab.value && (
                <div className="h-1 w-[18px] rounded-full bg-[#5959EB]" />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded bg-gray-100 px-1 py-0.5 ${className}`}>
      <div className="relative">
        {/* 背景滑块 */}
        <div
          className="absolute bottom-0.5 top-0.5 rounded bg-white transition-all duration-300 ease-in-out"
          style={{
            left: `${activeIndex * (100 / tabs.length)}%`,
            width: `${100 / tabs.length}%`
          }}
        />

        {/* Tab按钮 */}
        {tabs.map((tab, index) => (
          <button
            key={tab.value}
            className={`relative cursor-pointer rounded px-3 py-1 text-xs transition-all duration-300 ease-in-out ${
              activeIndex === index ? 'font-medium text-black' : 'text-gray-500'
            }`}
            onClick={() => onChange?.(tab.value, index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabsCard;
